import React from "react";
import "./index.less";
import Loadable from "../../react-loadable";

const WeaDropdown = Loadable({
  loader: () => import("./Dropdown"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

WeaDropdown.ButtonSelect = Loadable({
  loader: () => import("./ButtonSelect"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaDropdown;



// WEBPACK FOOTER //
// ./ecology9/wea-dropdown/index.js